export default __webpack_public_path__ + "static/6913-e6430575bb1eeffe1b1732b1729e27bc.jpg";